import HeroBreadCrumb from "../../components/BreadCrumb/HeroBreadCrumb";
import Paragraph from "../../components/Paragraph/Paragraph";
import SectionBanner from "../../components/SectionBanner/SectionBanner";
import Tabs from "../../components/Tabs/Tabs";
import { ProductsContent } from "./Products-Content";

const Products: React.FC = () => {
    return (
        <>
            <HeroBreadCrumb
                content={ProductsContent.heroBreadCrumb}
                style={{minHeight: '21.875rem'}}
            />
            <section className="container py-4">
                <Paragraph
                    isPageHeader={true}
                    content={ProductsContent.paragraph1}
                />
            </section>

            <section className="container py-4">
                <Tabs type="dropdown" labelText={ProductsContent.productsList.labelText} tabs={ProductsContent.productsList.tabs} position="full-width" />
            </section>
            <SectionBanner
                linkClass="bg-light-grey2 py-4"
                content={ProductsContent.sectionBanner}
            />
        </>
    );
};

export default Products;
